import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import './styles/UnorderedList.scss';


class UnorderedList extends React.Component {
  render() {
    let { icon, message, preface, actions, className, extraClassMessage, extraClassPreface, extraClassItems } = this.props;

    return (
      <div className={ `unordered-list ${className}` }>
        <div className={`unordered-list-attention-message ${extraClassMessage}`}>
          { icon && <FontAwesome name={ icon }/> }
          { ` ${message}` }
        </div>

        { preface && <div className={`unordered-list-preface ${extraClassPreface}`}>{ preface }</div> }
        <div className="unordered-list-items">
          <ul className={`unordered-list-items ${extraClassItems}`}>
            { actions.map((object, i) => <li key={i}>{ object }</li>) }
          </ul>
        </div>
      </div>
    );
  }
}

UnorderedList.propTypes = {
  className: PropTypes.string
};

UnorderedList.defaultProps = {
  className: ''
};


export default UnorderedList;
